export default {"src":"/login-app/[GIT_HASH]/_next/static/media/arrow_forward.269b2b08.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};